import { useState } from 'react';
import { Link } from 'react-router-dom';

const STEPS = [
  {
    title: 'Explore Your Options',
    body: 'Browse available services and discover the support that may be appropriate for your needs—therapy, assessments, or organizational pathways.',
    cta: { label: 'Explore services', to: '/assessments' },
    icon: '1',
  },
  {
    title: 'Take the Next Step',
    body: 'Choose a therapist, book an available consultation, or submit a request for a specialized assessment service.',
    cta: { label: 'Find a Therapist', to: '/therapists' },
    icon: '2',
  },
  {
    title: 'Move Forward With Support',
    body: 'Begin with professional guidance, clear expectations, and a pathway suited to your circumstances.',
    cta: { label: 'Get Started', to: '/register' },
    icon: '3',
  },
] as const;

export function HowItWorksStepper() {
  const [active, setActive] = useState(0);
  const step = STEPS[active]!;

  return (
    <div className="how-it-works">
      <div className="how-it-works-tabs" role="tablist" aria-label="How MyLighthouse works">
        {STEPS.map((item, index) => (
          <button
            key={item.title}
            type="button"
            role="tab"
            aria-selected={active === index}
            className={`how-it-works-tab ${active === index ? 'is-active' : ''}`}
            onClick={() => setActive(index)}
          >
            <span className="how-it-works-tab-num">{item.icon}</span>
            <span className="how-it-works-tab-label">{item.title}</span>
          </button>
        ))}
      </div>
      <div className="how-it-works-panel card" role="tabpanel">
        <h3 className="font-display text-xl font-bold text-[var(--color-midnight)]">
          {step.title}
        </h3>
        <p className="mt-2 text-sm leading-relaxed text-[var(--color-text-secondary)]">
          {step.body}
        </p>
        <Link to={step.cta.to} className="btn-primary mt-5 inline-flex text-sm">
          {step.cta.label} →
        </Link>
      </div>
    </div>
  );
}
